var _g, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 736,
    height: 980,
    viewBox: "0 0 736 980",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_174_1930)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.5,
    cy: 466,
    rx: 203.5,
    ry: 314,
    fill: "#F1F58F",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.05 233.529C335.576 240.261 162.439 260.752 225.689 288.864L477.7 331.274C530.878 340.833 564.597 369.888 274.044 409.632C214.041 422.557 176.204 452.607 504.877 469.41C537.231 477.353 574.621 497.037 465.346 512.224C443.933 519.359 402.096 546.879 406.049 599.871",
    stroke: "black",
    strokeWidth: 1.41172,
    strokeDasharray: "12.71 12.71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M595.753 626.694C595.753 637.089 590.419 647.03 580.694 656.109C570.968 665.189 556.876 673.382 539.432 680.271C504.547 694.046 456.33 702.574 403.053 702.574C349.776 702.574 301.559 694.046 266.674 680.271C249.23 673.382 235.138 665.189 225.412 656.109C215.687 647.03 210.353 637.089 210.353 626.694C210.353 616.298 215.687 606.358 225.412 597.279C235.138 588.199 249.23 580.005 266.674 573.117C301.559 559.342 349.776 550.814 403.053 550.814C456.33 550.814 504.547 559.342 539.432 573.117C556.876 580.005 570.968 588.199 580.694 597.279C590.419 606.358 595.753 616.298 595.753 626.694Z",
    stroke: "black",
    strokeWidth: 0.705861
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.53,
    cy: 614.676,
    rx: 104.868,
    ry: 49.0974,
    fill: "#141514",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.166,
    cy: 613.282,
    rx: 29.9991,
    ry: 13.4114,
    fill: "#141514"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.347 677.516C374.356 677.516 346.994 674.08 323.72 667.642C300.447 661.205 282.307 652.055 271.595 641.349C260.884 630.644 258.081 618.864 263.542 607.5C269.002 596.135 282.481 585.696 302.274 577.502C322.067 569.309 347.284 563.729 374.737 561.469C402.19 559.208 430.646 560.368 456.507 564.803C482.367 569.237 504.47 576.746 520.021 586.38C535.572 596.015 543.873 607.342 543.873 618.929",
    stroke: "black",
    strokeWidth: 0.705861
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315.422 625.94C309.405 617.173 310.604 607.775 318.815 599.348C327.026 590.92 341.74 583.984 360.45 579.722C379.161 575.459 400.71 574.135 421.427 575.973C442.143 577.811 460.745 582.698 474.062 589.802C487.379 596.907 494.588 605.788 494.461 614.933C494.333 624.077 486.877 632.92 473.363 639.954C459.848 646.989 441.112 651.779 420.346 653.509C399.58 655.239 378.069 653.802 359.478 649.442",
    stroke: "black",
    strokeWidth: 0.705861
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_174_1930)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 26.1177,
    ry: 38.1083,
    transform: "matrix(-0.967354 0.25343 0.25343 0.967354 295.745 416.773)",
    fill: "#208D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.504 423.124C274.124 433.124 279.264 441.404 285.402 446.72C291.545 452.04 298.594 454.327 305.135 452.613C311.675 450.899 316.697 445.451 319.443 437.802C322.186 430.159 322.606 420.422 319.986 410.422C317.366 400.422 312.226 392.142 306.088 386.826C299.945 381.506 292.896 379.219 286.356 380.933C279.815 382.647 274.793 388.095 272.047 395.744C269.304 403.387 268.884 413.124 271.504 423.124Z",
    stroke: "black",
    strokeWidth: 2.11758
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M302.144 411.466L294.099 406.082L293.768 405.86L293.588 406.216L289.218 414.852L284.908 411.985L291.82 398.417L304.494 406.853L302.144 411.466ZM286.975 419.204L284.654 423.808L280.316 420.946L282.664 416.335L286.975 419.204ZM312.859 412.423L310.511 417.033L306.231 414.159L308.558 409.59L312.859 412.423ZM288.721 426.544L291.072 421.933L299.107 427.281L299.438 427.502L299.618 427.147L303.988 418.51L308.297 421.378L301.386 434.946L288.721 426.544ZM299.933 415.809L297.582 420.422L293.284 417.589L295.634 412.974L299.933 415.809Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.705861
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_174_1930)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 32.5068,
    ry: 44.3847,
    transform: "matrix(-0.984306 0.176473 0.176473 0.984306 362.763 279.425)",
    fill: "#FB423D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.808 284.974C333.936 296.841 339.378 306.91 346.407 313.607C353.436 320.304 361.985 323.581 370.409 322.071C378.832 320.56 385.711 314.518 389.975 305.795C394.239 297.074 395.845 285.741 393.717 273.875C391.59 262.009 386.147 251.94 379.119 245.243C372.09 238.545 363.54 235.269 355.117 236.779C346.694 238.289 339.815 244.332 335.55 253.054C331.286 261.776 329.681 273.108 331.808 284.974Z",
    stroke: "black",
    strokeWidth: 2.11758
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M349.815 267.074L355.083 266.016L355.083 266.016L354.358 262.285C354.319 262.087 354.352 261.884 354.448 261.72C354.545 261.556 354.697 261.444 354.873 261.41L357.32 260.935C357.495 260.901 357.678 260.947 357.829 261.063C357.98 261.178 358.086 261.355 358.125 261.553L358.782 264.937L358.85 265.284L359.196 265.216L360.016 265.057L360.362 264.99L360.295 264.643L359.637 261.259C359.599 261.061 359.631 260.857 359.728 260.693C359.824 260.529 359.977 260.418 360.152 260.384L362.792 259.871C362.967 259.837 363.15 259.883 363.301 259.999C363.452 260.115 363.558 260.291 363.597 260.489L364.255 263.873L364.322 264.22L364.565 264.173C369.198 263.272 372.773 265.458 373.662 270.031C374.349 273.563 372.986 276.073 370.682 277.33C370.625 277.333 370.569 277.337 370.513 277.342L370.519 277.416C370.509 277.421 370.499 277.426 370.49 277.431L370.541 277.693C370.567 277.691 370.593 277.689 370.619 277.688L370.649 277.746C370.692 277.724 370.736 277.701 370.779 277.678C373.876 277.536 376.877 279.484 377.727 283.855C378.764 289.188 375.604 293.002 370.346 294.024L370.124 294.068L370.191 294.414L370.849 297.798C370.888 297.996 370.855 298.2 370.758 298.364C370.662 298.528 370.509 298.639 370.334 298.673L367.694 299.186C367.33 299.257 366.97 298.98 366.889 298.568L366.232 295.184L366.164 294.837L365.818 294.905L365.191 295.026L364.844 295.094L364.912 295.44L365.57 298.825C365.608 299.023 365.575 299.226 365.479 299.39C365.382 299.554 365.23 299.665 365.055 299.699L362.415 300.212C362.051 300.283 361.69 300.006 361.61 299.594L360.952 296.21L360.954 296.209L360.885 295.863L360.538 295.931L360.539 295.933L355.617 296.922C355.252 296.992 354.892 296.716 354.812 296.304L354.232 293.319C354.193 293.121 354.226 292.918 354.322 292.754C354.419 292.59 354.571 292.478 354.746 292.444L349.815 267.074ZM349.815 267.074C349.64 267.108 349.487 267.219 349.391 267.383C349.294 267.547 349.262 267.75 349.3 267.948L349.874 270.9C349.953 271.309 350.309 271.59 350.674 271.519L349.815 267.074ZM361.231 295.796L361.163 295.448L360.815 295.517L355.549 296.575C355.549 296.575 355.549 296.575 355.549 296.575C355.414 296.601 355.209 296.498 355.158 296.236L354.578 293.251C354.555 293.133 354.576 293.018 354.626 292.933C354.676 292.849 354.745 292.804 354.814 292.791L354.814 292.791L354.82 292.79L356.785 292.374C357.415 292.25 357.955 291.851 358.291 291.279C358.627 290.708 358.737 290.01 358.606 289.337L355.412 272.906C355.282 272.236 354.921 271.632 354.399 271.228C353.876 270.823 353.229 270.652 352.599 270.77L352.599 270.77L352.594 270.771L350.606 271.173C350.606 271.173 350.606 271.173 350.605 271.173C350.475 271.197 350.271 271.096 350.22 270.833L349.646 267.881C349.623 267.762 349.645 267.647 349.695 267.562C349.744 267.479 349.814 267.434 349.882 267.42L349.884 267.42L355.152 266.362L355.496 266.293L355.429 265.948L354.704 262.217C354.681 262.099 354.702 261.984 354.752 261.899C354.802 261.815 354.871 261.77 354.94 261.757L357.387 261.281C357.455 261.268 357.537 261.284 357.614 261.343C357.692 261.403 357.755 261.501 357.778 261.62L358.503 265.351L358.571 265.697L358.917 265.63L360.43 265.336L360.776 265.269L360.709 264.922L359.984 261.191C359.961 261.072 359.982 260.958 360.032 260.872C360.081 260.789 360.151 260.744 360.219 260.731L362.859 260.217C362.928 260.204 363.009 260.22 363.086 260.279C363.164 260.339 363.227 260.437 363.25 260.556L363.976 264.287L364.043 264.634L364.389 264.566L364.632 264.519C366.88 264.082 368.836 264.4 370.328 265.347C371.818 266.293 372.887 267.891 373.316 270.098C373.656 271.852 373.47 273.319 372.928 274.485C372.386 275.651 371.477 276.538 370.331 277.116L370.092 277.236L370.143 277.498L370.194 277.761L370.255 278.071L370.569 278.045C372.078 277.924 373.567 278.322 374.782 279.275C375.996 280.226 376.959 281.751 377.381 283.922C377.882 286.502 377.366 288.685 376.115 290.344C374.861 292.008 372.842 293.18 370.278 293.678L370.057 293.721L369.71 293.788L369.777 294.135L370.503 297.866C370.526 297.985 370.504 298.1 370.454 298.185C370.405 298.268 370.335 298.313 370.267 298.327L367.627 298.84C367.493 298.866 367.287 298.763 367.236 298.501L366.511 294.77L366.443 294.423L366.097 294.491L364.777 294.747L364.431 294.815L364.498 295.161L365.223 298.892C365.246 299.011 365.225 299.126 365.175 299.211C365.126 299.294 365.056 299.339 364.987 299.353L362.348 299.866C362.213 299.892 362.007 299.789 361.956 299.527L361.231 295.796ZM359.645 269.375L359.299 269.443L359.366 269.789L360.918 277.771L360.985 278.117L361.331 278.05L364.71 277.393C366.47 277.051 367.731 276.417 368.48 275.476C369.237 274.524 369.42 273.319 369.154 271.951C368.905 270.67 368.325 269.669 367.452 269.055C366.576 268.439 365.452 268.247 364.183 268.493L359.645 269.375ZM361.996 281.467L361.649 281.534L361.716 281.881L363.442 290.757L363.509 291.104L363.856 291.036L367.652 290.298C369.704 289.899 371.15 289.23 372.004 288.236C372.872 287.225 373.076 285.941 372.786 284.449C372.499 282.974 371.831 281.823 370.798 281.125C369.764 280.427 368.42 280.218 366.853 280.523L361.996 281.467Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.705861
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_174_1930)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 454.538,
    cy: 451.849,
    rx: 29.9991,
    ry: 42.7046,
    transform: "rotate(14.6806 454.538 451.849)",
    fill: "#0B80BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.533 459.183C479.593 470.406 473.746 479.685 466.721 485.628C459.694 491.573 451.573 494.124 443.983 492.135C436.394 490.147 430.567 483.942 427.357 475.315C424.149 466.691 423.602 455.737 426.542 444.515C429.482 433.292 435.33 424.014 442.354 418.071C449.382 412.125 457.503 409.575 465.092 411.563C472.681 413.551 478.508 419.756 481.718 428.383C484.927 437.007 485.473 447.961 482.533 459.183Z",
    stroke: "black",
    strokeWidth: 2.11758
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M450.321 463.161L450.481 463.351L450.714 463.264L463.076 458.667L447.769 473.703L441.8 453.093L450.321 463.161ZM459.324 429.594L464.781 454.883L451.394 459.866L442.162 448.958L459.324 429.594Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.705861
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M366.382 489.683L366.432 490.026L366.775 490.077L383.943 492.58L366.775 495.084L366.432 495.134L366.382 495.478L363.878 512.646L361.374 495.478L361.324 495.134L360.98 495.084L343.813 492.58L360.98 490.077L361.324 490.026L361.374 489.683L363.878 472.515L366.382 489.683Z",
    fill: "#FFB444",
    stroke: "black",
    strokeWidth: 0.931737
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.396 347.545L244.463 348.003L244.921 348.07L267.812 351.408L244.921 354.746L244.463 354.813L244.396 355.271L241.058 378.162L237.72 355.271L237.653 354.813L237.195 354.746L214.304 351.408L237.195 348.07L237.653 348.003L237.72 347.545L241.058 324.654L244.396 347.545Z",
    fill: "#FFB444",
    stroke: "black",
    strokeWidth: 1.24232
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M450.69 253.616L450.739 253.955L451.078 254.004L467.985 256.47L451.078 258.936L450.739 258.985L450.69 259.323L448.224 276.231L445.758 259.323L445.709 258.985L445.37 258.936L428.463 256.47L445.37 254.004L445.709 253.955L445.758 253.616L448.224 236.709L450.69 253.616Z",
    fill: "#FFB444",
    stroke: "black",
    strokeWidth: 0.917619
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_174_1930",
    x: 0,
    y: -48,
    width: 807,
    height: 1028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_174_1930"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_174_1930",
    x: 263.043,
    y: 379.313,
    width: 59.7575,
    height: 77.7436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.64689,
    dy: 2.82344
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_174_1930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_174_1930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_174_1930",
    x: 324.167,
    y: 235.356,
    width: 71.5451,
    height: 90.9599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.64689,
    dy: 2.82344
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_174_1930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_174_1930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_174_1930",
    x: 423.557,
    y: 409.838,
    width: 67.6081,
    height: 86.8465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.64689,
    dy: 2.82344
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_174_1930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_174_1930",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/HeroImage.44ed967175d14594af95f7a41bd8aea8.svg";
export { ForwardRef as ReactComponent };